












































































import { Dialog } from 'element-ui'
import { Component, Vue, Prop, Ref } from 'vue-property-decorator'

import FacebookButton from '@/components/FacebookButton.vue'
import InlineCustomerWidget from '@/components/InlineCustomerWidget.vue'

import Customer from '@/models/customer'
import Invitation from '@/models/invitation'
import Passenger, {
  PassengerInfoStatuses,
  PassengerStatuses,
} from '@/models/passenger'

import getAbilitiesFor from '@/abilities/passenger/abilities'
import axios from '@/axios-module'

@Component({
  components: {
    [Dialog.name]: Dialog,
    FacebookButton,
    InlineCustomerWidget,
  },
})
export default class PassengerDetailsModal extends Vue {
  @Prop() passenger!: Passenger
  @Prop() visible!: boolean
  @Prop() currentCustomer!: Customer
  @Ref() readonly invitationLinkInput!: HTMLInputElement

  copySuccess = false
  invitationLink = ''

  async mounted() {
    if (this.invitable) {
      this.invitationLink = await this.retrieveInvitationLink()
    }
  }

  async updated() {
    if (this.invitable) {
      this.invitationLink = await this.retrieveInvitationLink()
    }
  }

  get title() {
    return !this.passengerInfoIsComplete ? 'Add Passenger' : 'Edit Passenger'
  }

  get updatable() {
    return getAbilitiesFor(this.passenger).can('update', 'Passenger')
  }

  get deletable() {
    return getAbilitiesFor(this.passenger).can('delete', 'Passenger')
  }

  get invitable() {
    return getAbilitiesFor(this.passenger).can('invite', 'Passenger')
  }

  get passengerInfoIsComplete(): boolean {
    return this.passenger.personalInfoStatus !== PassengerInfoStatuses.Empty
  }

  get passengerCancelled(): boolean {
    return this.passenger.passengerStatus === PassengerStatuses.Cancelled
  }

  copyInvitationLink() {
    const { invitationLinkInput } = this

    if (invitationLinkInput) {
      invitationLinkInput.focus()
      invitationLinkInput.select()
      document.execCommand('copy')
      this.copySuccess = true
    }
  }

  async facebookInvite() {
    const link = await this.retrieveInvitationLink()

    FB.ui({ method: 'send', link }, () => undefined)
  }

  async retrieveInvitationLink(): Promise<string> {
    try {
      const response = await axios.post(
        `/customer/passengers/${this.passenger.id}/invitations`,
      )
      const invitation: Invitation = response.data

      const invitationRoute = this.$router.resolve({
        name: 'invitePage',
        params: { autologinToken: invitation.autologinToken },
      })

      return window.location.origin + invitationRoute.href
    } catch (e) {
      throw new Error(`retrieveInvitationLink ${e}`)
    }
  }
}
